import React from 'react';
import { LinkReview } from 'components';

export const LinkReviewPage = props => {
    return <LinkReview {...props} />;
};
